// Colour Tiles: light and bright, every menu category has its own colour so items are
// found by colour first. Big tiles, comfortable spacing.
import { defineTheme } from './types.js';

export const colourTiles = defineTheme({
  id: 'colour-tiles',
  name: 'Colour Tiles',
  description:
    'Bright and colour-coded: each menu category gets its own colour. Big, friendly tiles.',
  look: {
    colorScheme: 'light',
    colors: {
      bg: '#f3f5f9',
      surface: '#ffffff',
      surfaceRaised: '#ffffff',
      surfaceSunken: '#e9edf4',
      border: '#d9dfe8',
      borderStrong: '#7b8597',
      text: '#111827',
      textMuted: '#4b5563',
      accent: '#2557d6',
      accentHover: '#1e47b0',
      onAccent: '#ffffff',
      accentSoft: '#e0e9fd',
      onAccentSoft: '#1a3c94',
      focus: '#7c3aed',
      success: '#15803d',
      onSuccess: '#ffffff',
      warning: '#b45309',
      onWarning: '#ffffff',
      danger: '#c0262d',
      onDanger: '#ffffff',
      info: '#0e6aa8',
      onInfo: '#ffffff',
      veg: '#15803d',
      nonVeg: '#b42318',
      overlay: '#11182799',
      table: {
        free: { bg: '#dcf5e3', fg: '#14532d' },
        occupied: { bg: '#ffe4c2', fg: '#7a3500' },
        billed: { bg: '#dbe7ff', fg: '#1a3c94' },
        reserved: { bg: '#eee1ff', fg: '#5b21b6' },
      },
      categories: [
        { bg: '#ffd8b0', fg: '#6b2c00' },
        { bg: '#c6efd2', fg: '#0f4a26' },
        { bg: '#cfe0ff', fg: '#163a8a' },
        { bg: '#ffd1e0', fg: '#7f1442' },
        { bg: '#e5d6ff', fg: '#4c1d95' },
        { bg: '#c3eeea', fg: '#0f4744' },
        { bg: '#fff0a8', fg: '#594100' },
        { bg: '#ffd0cc', fg: '#7a1a12' },
      ],
    },
    shadows: {
      sm: '0 1px 2px #11182714',
      md: '0 4px 14px #1118271f',
      lg: '0 14px 36px #11182729',
    },
  },
  typography: {
    fontSans:
      '"Nunito Sans", "Segoe UI", system-ui, -apple-system, "Noto Sans", Roboto, Arial, sans-serif',
    fontNumeric:
      '"Nunito Sans", "Segoe UI", system-ui, -apple-system, "Noto Sans", Roboto, Arial, sans-serif',
    sizes: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.375rem',
      xxl: '1.75rem',
      display: '2.25rem',
    },
    lineHeight: 1.5,
    weights: { regular: 400, medium: 600, bold: 800 },
  },
  radii: { sm: '8px', md: '12px', lg: '20px', pill: '999px' },
  space: 4,
  touchMin: 56,
  features: {
    itemCodeEntry: false,
    tableStrip: false,
    categoryColours: true,
    density: 'comfortable',
    keyboardShortcuts: false,
  },
});
